var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import * as yup from 'yup';
import fieldValidationMessageIds from './validationMessages';
import { passwordSchema } from './common';
import { createAuthFormHook } from './createAuthFormHook';
export var EChangePasswordFormField;
(function (EChangePasswordFormField) {
    EChangePasswordFormField["OLD_PASSWORD"] = "oldPassword";
    EChangePasswordFormField["NEW_PASSWORD"] = "newPassword";
    EChangePasswordFormField["REPEAT_NEW_PASSWORD"] = "repeatNewPassword";
    EChangePasswordFormField["IS_OLD_PASSWORD_REQUIRED"] = "isOldPasswordRequired";
})(EChangePasswordFormField || (EChangePasswordFormField = {}));
var required = fieldValidationMessageIds.required, passwordEntriesDoNotMatch = fieldValidationMessageIds.passwordEntriesDoNotMatch;
export var changePasswordFormSchema = yup.object((_a = {},
    _a[EChangePasswordFormField.NEW_PASSWORD] = passwordSchema,
    _a[EChangePasswordFormField.REPEAT_NEW_PASSWORD] = yup
        .string()
        .required(required)
        .oneOf([yup.ref(EChangePasswordFormField.NEW_PASSWORD), ''], passwordEntriesDoNotMatch),
    _a[EChangePasswordFormField.IS_OLD_PASSWORD_REQUIRED] = yup.boolean(),
    _a[EChangePasswordFormField.OLD_PASSWORD] = yup
        .string()
        .when(EChangePasswordFormField.IS_OLD_PASSWORD_REQUIRED, function (_a, schema) {
        var isRequired = _a[0];
        return isRequired ? schema.required(required) : schema;
    }),
    _a));
var useChangePassword = createAuthFormHook(changePasswordFormSchema);
export var useChangePasswordForm = function (onSubmit, _a, useFormProps) {
    var _b;
    var _c = _a.isOldPasswordRequired, isOldPasswordRequired = _c === void 0 ? true : _c;
    return useChangePassword(onSubmit, __assign(__assign({}, useFormProps), { defaultValues: __assign(__assign({}, useFormProps === null || useFormProps === void 0 ? void 0 : useFormProps.defaultValues), (_b = {}, _b[EChangePasswordFormField.IS_OLD_PASSWORD_REQUIRED] = isOldPasswordRequired, _b)) }));
};
